import { configureStore } from '@reduxjs/toolkit'

import clientDataReducer from './slices/clientDataSlice'
import filtersReducer from './slices/filterSlice'
import genericModalReducer from './slices/modalSlice'

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    genericModal: genericModalReducer,
    clientData: clientDataReducer
  }
})
